<template>
    <div>
        <span class="yf">{{item.base.shirt_number}}</span>
        <span class="yy"></span>
        <span class="name">{{item.base.player_name}}</span>
        <span class="score" v-if="stut == 2 || parseFloat(item.base.rating) <= 0"></span>
        <span class="score" v-else :style="{background:color(item.base.rating) }">{{item.base.rating}}<i class="el-icon-caret-right"></i></span>
        <span class="img">
            <img v-if="item.status.showExchange" src="../../../assets/img/matchDetails/linBox_hr.png" alt="">
            <img v-if="item.status.showBlackBall" src="../../../assets/img/matchDetails/linBox_go.png" alt="">
            <img v-if="item.status.showYellowPaper" src="../../../assets/img/matchDetails/linBox_yellow.png" alt="">
            <img v-if="item.status.showRedPaper" src="../../../assets/img/matchList/paper_red.png" alt=""/>
            <img v-if="item.status.showTwoPaper" src="../../../assets/img/matchList/paper_two.png" alt=""/>
            <!-- 点球 -->
            <img v-if="item.status.showYellowBall" src="../../../assets/img/matchList/goal_dq.png" alt="">
            <!-- 乌龙球 -->
            <img v-if="item.status.showRedBall" src="../../../assets/img/matchList/goal_wl.png" alt="">
        </span>
    </div>
</template>

<script>
export default {
    props: ["item","stut"],
    methods: {
        color (score) {
            if (parseFloat(score)  >= 6 && parseFloat(score)  < 8) {
                return '#6ED590'
            }
            if (parseFloat(score)  >= 8) {
                return '#FF7E65'
            } else {
                return '#52C9E3'
            }
        }
    }
}
</script>

<style>

</style>